import React, { FC, useMemo } from 'react'
import { Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { cn } from 'shared/utils'
import { IIsaacLink } from 'shared/interfaces'
import { IIsaacTableProps } from './IsaacTable.props'

import styles from './IsaacTable.module.scss'

const IsaacTable: FC<IIsaacTableProps> = ({ isaakLinks, className }) => {
  const columns: ColumnsType<IIsaacLink>[] = useMemo(
    () => [
      {
        title: 'Description',
        dataIndex: 'title',
        key: 'titleDescription',
        sortable: false,
        width: '50%',
        align: 'left'
      },
      {
        title: 'ISAAC Link',
        dataIndex: 'url',
        key: 'description',
        sortable: false,
        width: '50%',
        align: 'left',
        render: (value, record, idx) => <a href={value} className={styles.tableLink}>{value}</a>
      }
    ],
    []
  )

  return (
    <Table
      tableLayout="fixed"
      className={cn(className, styles.table)}
      columns={columns}
      data={isaakLinks}
      rowKey={({ title }) => title}
      pagination={false}
    />
  )
}

export default IsaacTable
